module.exports = __webpack_public_path__ + "media/priceMyRentalHero.3268e94d.webp";